module.exports = require("./build/ReactDocumentEvents.js");



//////////////////
// WEBPACK FOOTER
// ./~/react-document-events/index.js
// module id = 319
// module chunks = 0